/**
 * AdminUsersPage — the All Users directory (§7) as a top-level admin rail
 * destination (/admin/users), promoted out of the Settings tab. Wraps the
 * same AdminAllUsersPanel (directory + view-as wiring) in the admin shell.
 */
import React from 'react';
import AppLayout from '../../components/AppLayout';
import AdminAllUsersPanel from '../../components/admin/AdminAllUsersPanel';
import SeatsPanel from '../../components/admin/SeatsPanel';
import { isSeatRoleSotEnabled } from '../../config/seatRoles';

export default function AdminUsersPage() {
  return (
    <AppLayout>
      <div className="max-w-5xl mx-auto p-6">
        <AdminAllUsersPanel />
        {isSeatRoleSotEnabled() && (
          <div className="mt-8">
            <SeatsPanel />
          </div>
        )}
      </div>
    </AppLayout>
  );
}
